import React from "react";
import "./Chart.css";
import ChartBar from "./ChartBar";

function Chart(props) {
  const dataPointsValues = props.dataPoints.map((datapoint) => datapoint.value);

  const maximum = Math.max(...dataPointsValues);
  return (
    <div className="chart">
      {props.dataPoints.map((datapoint) => (
        <ChartBar
          label={datapoint.label}
          key={datapoint.label}
          value={datapoint.value}
          maxValue={maximum}
        />
      ))}
    </div>
  );
}

export default Chart;
